import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { GeofencingMgtService } from '../../services/geofencing-mgt.service';
import { AppFilter } from '@app/shared/models';
import { HttpClient } from '@angular/common/http';

interface IAddCountryModalContext {
  data: any;
  title?: string;
}

@Component({
  selector: 'app-add-country-modal',
  templateUrl: './add-country-modal.component.html',
  styleUrls: ['./add-country-modal.component.scss'],
})
export class AddCountryModalComponent implements OnInit {
  selectedProfile: any;
  filter: AppFilter = new AppFilter();
  success: any;
  error: any;
  user: any;
  pending: boolean;
  rows: number = 2;
  countries: any = [];
  country: any;
  profiles: any[] = [];

  constructor(
    public modal: SuiModal<IAddCountryModalContext, void, void>,
    private geofenceSVC: GeofencingMgtService,
    private http: HttpClient
  ) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.fetchCountries();
  }
  ngOnInit(): void {}
  fetchCountries() {
    this.pending = true;
    this.geofenceSVC.getAllCountries().subscribe(
      (data: any) => {
        this.pending = false;
        // Combine all rows into a single array
        this.countries = data.rows.flat();
        this.countries.reverse();
      },
      (error) => {
        this.pending = false;
        this.error = error.error ? error.error : error;
      }
    );
  }
  addCountry(country) {
    this.pending = true;
    const body = {
      countryName: country.countryName,
      status: this.modal.context.data.isCountryAllowed
        ? 'ALLOWED'
        : 'DISALLOWED',
    };
    const requestBody = { body: JSON.stringify(body) };
    this.geofenceSVC
      .addCountry({
        body: body,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Country Added Successfully';
          setTimeout(() => {
            this.modal.approve();
          }, 500);
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }
}

export class AddCountryModal extends ComponentModalConfig<
  IAddCountryModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(AddCountryModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
